export const HOT_NOTE_MAX_CHARS = 500;
export const HOT_NOTE_BG_COLOR = '#fff9e6';
